import React from 'react';

const FoundingOffer: React.FC = () => {
  return (
    <section id="founding-offer" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-8 md:p-12 border border-blue-100 relative overflow-hidden shadow-sm">
          {/* Decorative glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-400 rounded-full filter blur-3xl opacity-10 -translate-y-1/2 translate-x-1/2" />
          
          <div className="relative z-10 max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-wider mb-6">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
              </span>
              Limited Opportunity
            </div>
            
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Founding Client Program — 5 spots
            </h2>
            
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                We're working with our first 5 clients at founding-client pricing in exchange for a written case study. 
                You get a custom CRM or operations tool built and deployed in 2–4 weeks for <strong>$2,500 down</strong>. 
                We get to publish your story (with your approval) and learn alongside you.
              </p>
              
              <p>
                If your business has a process bleeding time or money, let's talk. 
                <strong> Two spots already taken. Three remaining.</strong>
              </p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              >
                Secure Your Spot
              </a>
              <div className="flex items-center gap-3 px-2">
                <div className="flex -space-x-2">
                  {[1, 2].map((i) => (
                    <div key={i} className="w-8 h-8 rounded-full bg-blue-200 border-2 border-white flex items-center justify-center text-[10px] font-bold text-blue-700">
                      Client
                    </div>
                  ))}
                  <div className="w-8 h-8 rounded-full bg-gray-100 border-2 border-white border-dashed flex items-center justify-center text-[10px] font-bold text-gray-400">
                    +3
                  </div>
                </div>
                <span className="text-sm font-medium text-gray-500">3 slots left</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundingOffer;
